'use strict';

var version = "0.0.0";

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

var defaults = {
  time: 5,
  mute: false,
  type_countDown: "video",
  src: {
    type: 'application/x-mpegURL',
    src: '' //Advertisement source, can also be an object like {src:"file.mp4",type:"video/mp4"}
  }, href: '', //Advertised url
  target: '_blank', //Target to open the ad url in
  allowSkip: true, //Allow skipping of the ad after a certain period
  skipTime: 5, //Seconds after which the ad can be skipped
  repeatAd: false, //Show the ad only once or after every conten
  adSign: false, //Advertisement sign
  showRemaining: false, //Show remaining ad time > works if allowSkip is false
  adsOptions: {}, //Options passed to the ads plugin
  loop: true,
  lang: {
    'skip': 'Skip',
    'skip in': 'Skip in ',
    'advertisement': 'Advertisement',
    'video start in': 'Video will start in: '
  }
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function countdown
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */

var countdown = function countdown(options) {
  var settings;
  var player = this;
  var video = document.getElementsByTagName("video")[0];
  var countdownOverlay;
  var countdownText;
  var isCounting = false;
  var isDone = false;
  var isPlay = false;
  var src_live = player.currentSrc();
  var afterLive = false;
  var timer, isElementInViewport, checkIsVisible, handler, startTimer, cleanup, setup;

  var userAgent = navigator.userAgent;
  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i) || userAgent.match(/Android/i)) {
    return;
  }

  if (videojs.VERSION.split('.')[0] >= 5) {
    settings = videojs.mergeOptions(defaults, options);
  } else {
    settings = videojs.util.mergeOptions(defaults, options);
  }
  // Translations
  videojs.addLanguage('de', {
    'Starts in {{seconds}} seconds...': 'Beginnt in {{seconds}} Sekunden…',
    '“{{title}}” is starting in {{seconds}} seconds...': '„{{title}}“ fängt in {{seconds}} Sekunden an…'
  });

  setup = function setup() {
    if (afterLive) {
      if (document.getElementById('vjs-countdown')) {
        player.el().removeChild(document.getElementById('vjs-countdown'));
      }
      // Change player src to ad src
      player.src(settings.src);
      player.one('durationchange', function () {
        player.play();
        player.controlBar.hide();
        video.setAttribute("loop", false);
      });

      //Fallback in case preload = none
      player.one('progress', function () {
        player.play();
        player.controlBar.hide();
        video.setAttribute("loop", false);
      });

      player.one('ended', function () {
        if (isPlay === false) {
          video.setAttribute("loop", false);
          player.controlBar.show();
          player.play();
        }
      });
      afterLive = false;
    } else {
      var html_var = "";
      countdownOverlay = document.createElement('div');
      countdownOverlay.className = 'vjs-countdown';
      countdownOverlay.id = 'vjs-countdown';
      countdownText = document.createElement('div');
      countdownText.className = "countdown-text-wrapper";
      if (player.mediainfo && player.mediainfo.name && player.mediainfo.name !== '') {
        countdownText.innerHTML = '<div class="starts-in">' + player.localize('“{{title}}” is starting in').replace('{{title}}', player.mediainfo.name).toUpperCase() + '</div><span class="vjs-overlay-seconds"> </span>';
      } else {
        countdownText.innerHTML = '<div class="starts-in">' + player.localize('Starts in...').toUpperCase() + '</div><span class="vjs-overlay-seconds"> </span>';
      }
      if (settings.type_countDown === "countdown") {
        html_var = ' <div class="vjs-content-countdown">\n                <div class="vjs-nbr-countdown"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 909.84 693.235">\n  <g id="live" transform="translate(-40.152 -96)">\n    <path id="Trace_1" data-name="Trac\xE9 1" d="M280.136,204.657C266.108,190.071,252,175.4,236.868,159.665c-152.793,119.9-138.781,350.1,1.581,450.444l46.823-42.4C171.028,480.074,153.993,310.3,280.136,204.657Z" transform="translate(77.777 56.593)"/>\n    <path id="Trace_2" data-name="Trac\xE9 2" d="M399.224,161.028l-43.632,44.354c56.5,45.776,88.477,106.307,87.485,181.365-.988,74.822-35,134.312-93.844,180.372l44.749,44.873C557.15,488.719,532.431,251.247,399.224,161.028Z" transform="translate(274.751 57.805)"/>\n    <path id="Trace_3" data-name="Trac\xE9 3" d="M321.013,234.792c-47.257-.463-84.439,36.037-84.979,83.417-.54,47.457,35.9,85.036,82.911,85.491,47.253.457,84.448-36.052,84.987-83.421C404.467,272.829,368.02,235.253,321.013,234.792Z" transform="translate(174.119 123.372)"/>\n    <path id="Trace_4" data-name="Trac\xE9 4" d="M242.573,142.8c-14.159-15.637-28.323-31.692-42.486-46.8-1.532,0-15.652,13.889-21.927,20.143a502.019,502.019,0,0,0-47.146,54.016C1.357,329.962,15.207,596.9,142.356,727.2a484.832,484.832,0,0,0,42.5,45.648c5.419,5.142,19.824,16.383,19.824,16.383s27.167-31.558,40.74-47.412C61.667,584.323,58.193,304.938,242.573,142.8Z" transform="translate(0)"/>\n    <path id="Trace_5" data-name="Trac\xE9 5" d="M516.216,158.03a484.833,484.833,0,0,0-42.5-45.648c-5.419-5.142-10.168-10.716-15.23-16.383-1.532,0-31.76,31.558-45.334,47.412C596.909,300.91,600.383,580.3,416,742.431c14.159,15.636,45.548,46.8,47.078,46.8,5.754-5.667,11.058-13.889,17.333-20.143a502,502,0,0,0,47.146-54.016C657.217,555.273,643.366,288.334,516.216,158.03Z" transform="translate(331.57)"/>\n  </g>\n</svg>' + countdownText.outerHTML + '</div>\n            \n\n            </div>';
      } else if (settings.type_countDown === "image") {
        html_var = '\n            <div class="vjs-content-for-image">\n            ' + countdownText.outerHTML + '\n            <div class="vjs-sub-content-for-image">\n                <img class="vjs-image-before-live" src= ' + settings.data.src + ' />\n\n                    <div class="vjs-text-for-image">' + settings.data.text_for_image + '</div>\n\n            </div>\n        </div>';
      } else if (settings.type_countDown === "text") {
        html_var = ' <div class="vjs-content-for-text">\n            ' + countdownText.outerHTML + '\n            <div class="text-before-live">' + settings.data.text_for_image + '</div>\n        </div>';
      } else if (settings.type_countDown === "video") {

        html_var = countdownText.outerHTML;
        // Change player src to ad src
        player.src(settings.src);
        player.one('durationchange', function () {
          player.play();
          player.controlBar.hide();
          video.setAttribute("loop", true);
        });

        //Fallback in case preload = none
        player.one('progress', function () {
          player.play();
          player.controlBar.hide();
          video.setAttribute("loop", true);
        });

        player.one('ended', function () {
          if (isPlay === false) {
            video.setAttribute("loop", false);
            player.controlBar.show();
            player.play();
          }
        });
      }
      countdownOverlay.innerHTML = html_var;
      player.el().appendChild(countdownOverlay);
      checkIsVisible(player.el());
    }
  };

  checkIsVisible = function checkIsVisible(el) {
    if (isElementInViewport(el) && !isDone && !isCounting) {
      if (settings.time === 0) {
        if (settings.mute) {
          player.muted(true);
        }
        player.play();
        player.controlBar.show();
        isPlay = true;
      } else {
        player.pause();
        player.currentTime(0);
        player.trigger('loadstart');
        player.hasStarted(false);
        player.posterImage.hide();
        player.bigPlayButton.hide();
        startTimer();
      }
    }
  };

  startTimer = function startTimer() {
    var secondsdisplay = countdownOverlay.querySelector('.vjs-overlay-seconds');
    var count = settings.time;
    secondsdisplay.innerHTML = timeToString(count);
    player.addClass('vjs-counting');
    isCounting = true;
    timer = window.setInterval(function () {
      count = count - 1;

      secondsdisplay.innerText = timeToString(count);
      if (count === 0) {
        if (settings.type_countDown !== "video") {
          if (settings.mute) {
            player.muted(true);
          }
          player.play();
        } else {
          cleanup();
          player.pause();
          var test = {
            type: 'application/x-mpegURL',
            src: src_live,
            withCredentials: false
          };
          player.src(test);
          player.one('durationchange', function () {
            player.play();
          });

          //Fallback in case preload = none
          player.one('progress', function () {
            player.play();
          });
          player.one('adloadstart', function () {
            player.play();
          });
        }
      }
    }, 1000);

    function timeToString(duration) {
      var hour = Math.floor(duration / 3600);
      var minute = Math.floor((duration - hour * 3600) / 60);
      var seconde = Math.floor(duration - hour * 3600 - minute * 60);
      var hours = hour > 9 ? hour : "0" + hour;
      var minutes = minute > 9 ? minute : "0" + minute;
      var secondes = seconde > 9 ? seconde : "0" + seconde;
      return hours + ":" + minutes + ":" + secondes;
    }
  };

  cleanup = function cleanup() {
    isCounting = false;
    player.removeClass('vjs-counting');
    player.controlBar.show();
    video.setAttribute("loop", false);
    window.clearInterval(timer);
  };

  // Add event listeners
  // TODO: If mobile attach to touchstart or something?

  player.one('loadstart', function () {
    setup();
    handler = function handler() {
      return checkIsVisible(player.el());
    };
    if (window.addEventListener) {
      window.addEventListener('DOMContentLoaded', handler, false);
      window.addEventListener('load', handler, false);
      window.addEventListener('scroll', handler, false);
      window.addEventListener('resize', handler, false);
    } else if (window.attachEvent) {
      window.attachEvent('onDOMContentLoaded', handler);
      window.attachEvent('onload', handler);
      window.attachEvent('onscroll', handler);
      window.attachEvent('onresize', handler);
    }

    // Cancel if playback starts
    player.on('play', function () {
      isDone = true;
      if (isCounting && settings.type_countDown !== "video") {
        cleanup();
      }
    });
  });
  player.on('afterLive', function () {
    afterLive = true;
    setup();
    handler = function handler() {
      return checkIsVisible(player.el());
    };
    if (window.addEventListener) {
      window.addEventListener('DOMContentLoaded', handler, false);
      window.addEventListener('load', handler, false);
      window.addEventListener('scroll', handler, false);
      window.addEventListener('resize', handler, false);
    } else if (window.attachEvent) {
      window.attachEvent('onDOMContentLoaded', handler);
      window.attachEvent('onload', handler);
      window.attachEvent('onscroll', handler);
      window.attachEvent('onresize', handler);
    }

    // Cancel if playback starts
    player.on('play', function () {
      isDone = true;
      if (isCounting && settings.type_countDown !== "video") {
        cleanup();
      }
    });
  });

  // http://stackoverflow.com/a/7557433/740233
  isElementInViewport = function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  };
};

/*const countdown = function(options) {
 this.ready(() => {
 onPlayerReady(this, videojs.mergeOptions(defaults, options));
 });
 };*/

// Register the plugin with video.js.
registerPlugin('countdown', countdown);

// Include the version number.
countdown.VERSION = version;

module.exports = countdown;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_countdown/dist/videojs-countdown.cjs.js
// module id = 727
// module chunks = 0